<template>
  <ckeditor :editor="editor" :value="content" @input="onEditorInput" :config="editorConfig"></ckeditor>
</template>

<script>
  import CKEditor from 'ckeditor4-vue';

  export default {
    components: {
      ckeditor: CKEditor.component
    },
    data() {
      return {
        editorConfig: {
          extraPlugins: 'font,colorbutton', // 添加字体和颜色插件
          toolbar: [
            { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'] },
            { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] },
            { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
            { name: 'colors', items: ['TextColor', 'BGColor'] },
            // { name: 'insert', items: ['Image', 'Table', 'MediaEmbed'] }, // 视频功能
            { name: 'insert', items: ['Image', 'Table', 'MediaEmbed'] }, // 添加图片按钮
            { name: 'links', items: ['Link', 'Unlink'] },
          ],
          font_names: 'Arial/Arial, Helvetica, sans-serif;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;Verdana/Verdana, Geneva, sans-serif',
          fontSize_sizes: '9/9px;11/11px;13/13px;16/16px;18/18px;21/21px;24/24px;28/28px;32/32px',
          language: 'zh-cn'
        },
        content: '1234343'
      };
    },
    methods: {
      onEditorInput(val) {
        console.log(val);
      }
    }
  }; 
</script>